document.addEventListener('DOMContentLoaded', function () {
    const footer = document.querySelector('.footer');

    if (!footer) return;

    const items = footer.querySelectorAll('.kt-grid__item');

    items.forEach(function (item) {
        const title = item.querySelector(':scope > h4');
        const nav = item.querySelector(':scope > nav');

        if (!title || !nav) return;

        title.addEventListener('click', function () {
            if (window.innerWidth > 767) return;

            const isOpen = item.classList.contains('is-open');

            // 전체 메뉴 닫기
            items.forEach(function (otherItem) {
                const otherNav = otherItem.querySelector(':scope > nav');

                otherItem.classList.remove('is-open');

                if (otherNav) {
                    otherNav.style.display = 'none';
                }
            });

            // 클릭한 메뉴가 닫혀있었다면 열기
            if (!isOpen) {
                item.classList.add('is-open');
                nav.style.display = 'block';
            }
        });
    });
});